var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mx-0 px-0"},[_c('b-container',{staticClass:"d-flex flex-column align-items-start p-0"},[_vm._t("header")],2),_c('b-container',{staticClass:"grid__cards p-0"},_vm._l((_vm.items),function(item,index){return _c('router-link',{key:((item.id) + "-" + index),staticClass:"stack-card-list__item",attrs:{"to":{
        name: 'stack-detail',
        params: { stackId: item.id }
      }}},[_c('StackCard',{attrs:{"item":item}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }